module.exports = __webpack_public_path__ + "img/120.b6cf4228.jpg";